module.exports = __webpack_public_path__ + "img/loader.889a6df4.svg";